import CustomModal from "../../../../../components/customModal/CustomModal";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import * as Yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import { DropDownValues } from "../../../../../utils/types";
import { handleQuantityInput } from "../../../../../utils/commonUtils";

export const InventoryTransferModel = ({
  locationDropDownVal,
  selectedItem,
  selectCurrentUserId,
  toggleInventoryTransferModal,
  inventoryTransactionsList,
  invTransTransfer,
  activeLocation,
  requiredDecimalPoint,
}: any) => {
  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: {
      quantity: "",
      referenceNumber: "",
      transactionId: inventoryTransactionsList?.find(
        (option: DropDownValues) => option.label.toLowerCase() === "transfer",
      )?.value,
      locationFromId: activeLocation ?? "",
      locationToId: "",
      verifyDate: new Date(),
      itemId: selectedItem.id,
      userId: selectCurrentUserId,
    },
    validationSchema: Yup.object({
      quantity: Yup.number()
        .min(0, "Quantity must be a positive number")
        .required("Quantity is Required"),
      locationFromId: Yup.string().required("Transfer From is Required"),
      locationToId: Yup.string().required("Transfer To is Required"),
    }),

    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      try {
        invTransTransfer(values);
      } catch (err: any) { }
      setSubmitting(false);
    },
  });

  const handleQtyInput = (e: React.FormEvent<HTMLInputElement>) => {
    handleQuantityInput(e, requiredDecimalPoint);
  };

  return (
    <CustomModal
      title="Transfer Inventory"
      content={
        <div className="modal--content--wrapper">
          <div className="modal--inputbox">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <Form.Label>Transfer From</Form.Label>
                <Select
                  classNamePrefix="react-select"
                  options={locationDropDownVal}
                  id="locationFromId"
                  name="locationFromId"
                  value={locationDropDownVal?.find(
                    (option: any) => option.value === values.locationFromId,
                  )}
                  onChange={(option: any) =>
                    handleChange("locationFromId")(option.value)
                  }
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase().trim())
                  }
                  className={`${touched.locationFromId && !!errors.locationFromId
                    ? "is-invalid-border"
                    : ""
                    } react-select-container `}
                />
                {touched.locationFromId && errors.locationFromId && (
                  <Form.Control.Feedback type="invalid">
                    {errors.locationFromId as string}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Transfer To</Form.Label>
                <Select
                  classNamePrefix="react-select"
                  options={locationDropDownVal}
                  id="locationToId"
                  name="locationToId"
                  value={locationDropDownVal?.find(
                    (option: any) => option.locationId === values.locationToId,
                  )}
                  onChange={(option: any) =>
                    handleChange("locationToId")(option.value)
                  }
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase().trim())
                  }
                  className={`${touched.locationToId && !!errors.locationToId
                    ? "is-invalid-border"
                    : ""
                    } react-select-container `}
                />
                {touched.locationToId && errors.locationToId && (
                  <Form.Control.Feedback type="invalid">
                    {errors.locationToId}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>
                  Quantity ({selectedItem?.unit?.unitName || ""})
                </Form.Label>
                <Form.Control
                  type="text"
                  inputMode="decimal"
                  placeholder="Enter Quantity"
                  id="quantity"
                  name="quantity"
                  onChange={handleChange}
                  onInput={handleQtyInput}
                  value={values.quantity}
                  isInvalid={touched.quantity && !!errors.quantity}
                />
                {touched.quantity && errors.quantity ? (
                  <Form.Control.Feedback type="invalid">
                    {errors.quantity}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Reference Info</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Reference Info"
                  id="referenceNumber"
                  name="referenceNumber"
                  onChange={handleChange}
                  value={values.referenceNumber}
                  isInvalid={
                    touched.referenceNumber && !!errors.referenceNumber
                  }
                />
                {touched.referenceNumber && errors.referenceNumber ? (
                  <Form.Control.Feedback type="invalid">
                    {errors.referenceNumber}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>
              <Form.Group className="full-width text-end">
                <Button
                  onClick={toggleInventoryTransferModal}
                  style={{ marginRight: "10px" }}
                  variant="outline-primary"
                >
                  Cancel
                </Button>
                <Button type="submit" variant="primary">
                  Transfer
                </Button>
              </Form.Group>
            </Form>
          </div>
        </div>
      }
      onClose={toggleInventoryTransferModal}
    />
  );
};
